import getTrackerPluginInitializer from './getTrackerPluginInitializer';

/**
 * Initializes and returns all of the plugins for the current trackerList
 * @async
 *
 * @param {array} options.trackerList - the list of trackers that need to be injected into the page
 * @returns {Promise<array>} - all the initialized plugins
 */
const getTrackerPlugins = async ({ trackerList }) =>
    Promise.all(
        trackerList.map(async (trackerDetails) => {
            const trackerPluginInitializer = await getTrackerPluginInitializer({
                trackerType: trackerDetails.tracker,
            });

            return trackerPluginInitializer({ tracker: trackerDetails });
        }),
    );

export default getTrackerPlugins;
